/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import {
  TGetInfrastructureGeoObjectsModel,
  IGetInfrastructureGeoObjectsRequest,
  IMappers,
  IGetInfrastructureGeoObjectsResponse,
  IGetInfrastructureGeoObjectsResponseError,
  TGetInfrastructureGeoObjectsResponse,
} from './types';

const defaultConfig: TGetInfrastructureGeoObjectsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'infrastructure-caching',
  pathApi: '/v1/get-infrastructure-geo-objects/',
  hostType: 'api',
} as TGetInfrastructureGeoObjectsModel;

function createGetInfrastructureGeoObjectsModel(
  parameters: IGetInfrastructureGeoObjectsRequest,
): TGetInfrastructureGeoObjectsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetInfrastructureGeoObjectsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetInfrastructureGeoObjectsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetInfrastructureGeoObjects<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetInfrastructureGeoObjectsOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetInfrastructureGeoObjectsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetInfrastructureGeoObjectsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetInfrastructureGeoObjectsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetInfrastructureGeoObjectsResponseError);
    }
  }

  return { response, statusCode } as TGetInfrastructureGeoObjectsResponse;
}

export { defaultConfig, createGetInfrastructureGeoObjectsModel, fetchGetInfrastructureGeoObjects };
